<template lang="html">
   <div class="fx-wizard">
      <div class="wizard-head clearfix">
         <div 
            class="head-content clearfix"  
            v-if="forms && forms.length > 0" 
            v-for="i in forms.length" 
            :data-tag="i -= 1"
            :class="{'active': current === (i-1)}"
         >
            <div class="icon l" :class="forms[i].icon || 'fa fa-user'"></div>
            <div class="content l">
               <div class="fx-h6">{{forms[i].title}}</div>
               <div class="text-muted">{{forms[i].subtitle}}</div>
            </div>
         </div>
      </div>
      <div class="wizard-pages">
         <div class="wizard-page" v-if="forms && forms.length > 0" v-for="i in forms.length">
            <span v-show="false">{{i -= 1}}</span>

            <div class="page-content" v-show="current === i">
               <Form 
                  v-if="forms && forms[i].forms"
                  classBinding="row" 
                  :ref="forms[i].name" 
                  :forms="forms[i].forms" 
                  :formData="forms[i].data"
               />
            </div>
         </div>
      </div>
      <div class="wizard-actions clearfix">
         <div class="btn l" v-show="current > 0" @click="previousPage">Previous</div>
         <div class="btn btn-primary r" v-show="current < forms.length" @click="nextPage">Next</div>
         <div class="btn btn-primary r" v-show="current === forms.length" @click="submit">
            Finish
            <div class="lds-ring" v-show="isLoading"><div></div><div></div><div></div><div></div></div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   components:{
      Form: () => import("./form"),
   },
   props:{
      forms:{
         type: Array,
         default: function(){
            return []
         }
      },
      loading: {
         type: Boolean,
         default: false
      },
   },
   watch: {
      loading(){
         this.isLoading = this.loading
      }
   },
   data () {
      return {
         current: 0,
         isLoading: this.loading
      }
   },
   methods: {
      previousPage() {
         if(this.current > 0){
            this.current--
         }
      },
      async nextPage() {
         if(this.current >= 0 && this.current < this.forms.length){
            let form_name = this.forms[this.current].name
            let hasErrors = await this.$refs[form_name][0].validate()
            
            if(hasErrors){
               notification.notify('warning','Validation Error','Resolve the validation errors to continue')
            }else{
               this.current++
            }
         }
      },
      submit(){
         this.$emit('submit')
      }
   },
}
</script>